











 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskIntegrationLinkIntegrationJira",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "issueKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cloudName",
      "storageKey": null
    }
  ],
  "type": "JiraIssue",
  "abstractKey": null
};

(node ).hash = "98515eebe1546dc129e078d4a082aac4";

export default node;
